import { render, staticRenderFns } from "./ItemQuantity.vue?vue&type=template&id=685234a2&"
import script from "./ItemQuantity.vue?vue&type=script&lang=js&"
export * from "./ItemQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports